const applyOpacity: (color: string, opacity_percentage: number) => string = (color, opacity_percentage) => {
  const opacity = Math.round(opacity_percentage * 255 / 100);
  const opacityConverted = opacity.toString(16).toUpperCase();
  const alpha_hex = opacityConverted.length === 1 ? `0${opacityConverted}` : opacityConverted;
  return `${color}${alpha_hex}`;
};

export default applyOpacity;
